import React, { useState, useEffect } from 'react';
import * as ui from '@digital/ui';

import CapexManagementSumary from '@app/views/crf/Modulo/ContaResultado/Dashboard/Graficos/capexManagementSumary';
import CapexManagement from '@app/views/crf/Modulo/ContaResultado/Dashboard/Graficos/capexManagement';
import CapexManagementGrafico from '@app/views/crf/Modulo/ContaResultado/Dashboard/Graficos/capexManagementGrafico';

import {
  CrfRelatorioCapexManeger,
  getAllCrfRelatorioExecutiveSummary
} from '@app/api/crf/crfRelatorioCicloOrcamentario';


const ExecutiveSummary = () => {
  const [relatorio, setRelatorio] = useState<CrfRelatorioCapexManeger>();

  useEffect(() => {
    getAllCrfRelatorioExecutiveSummary().then((data) => {
      if (data) {
        setRelatorio(data);
      }
    });
  }, [])

  return (
    <ui.SimpleView>
      <ui.GridView noform>
        {relatorio ? <CapexManagementSumary data={relatorio} /> : <></>}
        {relatorio ? <CapexManagementGrafico data={relatorio} /> : <></>}
        {relatorio ? <CapexManagement data={relatorio} /> : <></>}
      </ui.GridView>
    </ui.SimpleView>
  );
};

export default ExecutiveSummary;
